import { render } from "./LinksComponent.vue?vue&type=template&id=21b3d7a7"
import script from "./LinksComponent.vue?vue&type=script&lang=js"
export * from "./LinksComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__